import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import '../LegalPage/LegalPage.css';
import { EMAIL, PHONE_DISPLAY } from '../../constants/contactInfo.js';
import { Link } from 'react-router-dom';

function PersonalDataConsentPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="legalPage">
          <div className="legalPage__hero">
            <h2 className="legalPage__title">
              Согласие на обработку персональных данных
            </h2>
            <p className="legalPage__lead">
              Настоящее согласие действует в отношении сведений, которые
              пользователь указывает в форме обратной связи на сайте Самарского
              областного отделения ВДПО.
            </p>
          </div>

          <div className="legalPage__content">
            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                1. Какие данные предоставляются
              </h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">имя и фамилия;</li>
                <li className="legalPage__list-item">номер телефона;</li>
                <li className="legalPage__list-item">адрес электронной почты;</li>
                <li className="legalPage__list-item">
                  наименование организации, если пользователь решит его указать;
                </li>
                <li className="legalPage__list-item">
                  сведения об интересующей услуге и содержание сообщения.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                2. Цель обработки данных
              </h3>
              <p className="legalPage__text">
                Персональные данные обрабатываются для приема и рассмотрения
                обращения, подготовки ответа, уточнения деталей заявки,
                предоставления консультации, расчета стоимости работ и
                организации дальнейшего взаимодействия с заявителем.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                3. Действия с персональными данными
              </h3>
              <p className="legalPage__text">
                Пользователь дает согласие на сбор, запись, систематизацию,
                накопление, хранение, уточнение, использование, передачу
                уполномоченным лицам, обеспечивающим работу сайта и доставку
                электронных сообщений, блокирование, удаление и уничтожение
                персональных данных в объеме, необходимом для достижения
                указанной цели.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                4. Срок действия согласия
              </h3>
              <p className="legalPage__text">
                Согласие действует до достижения цели обработки обращения либо
                до момента его отзыва пользователем, если более длительный срок
                хранения не требуется по законодательству Российской Федерации.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">5. Отзыв согласия</h3>
              <p className="legalPage__text">
                Согласие может быть отозвано путем направления обращения
                оператору по телефону {PHONE_DISPLAY} или по электронной почте{' '}
                {EMAIL}. После получения отзыва обработка прекращается, за
                исключением случаев, когда дальнейшее хранение требуется по
                закону.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                6. Связанные документы
              </h3>
              <p className="legalPage__text">
                Дополнительные условия обработки размещены на страницах{' '}
                <Link to="/privacy-policy/" className="legalPage__link">
                  Политика обработки персональных данных
                </Link>{' '}
                и{' '}
                <Link to="/cookies-policy/" className="legalPage__link">
                  Файлы cookie и технические данные
                </Link>
                .
              </p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default PersonalDataConsentPage;
